const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const ScrollNotification = require("../components/scroll-notification");

class InsuranceModuleV2 {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `insurance-module insurance-module-v2 ${cssVariableKey}`);
    this.contentHash = {};
    this.typingIndicator = null;
  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleOnMessage(value) {
    let component = null;
    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];
      // Handle back
      const isAnswerNo = value.values.text && value.values.text.trim && value.values.text.trim().toLowerCase() === 'no';
      if (value.values.format === 'yes/back' && isAnswerNo) {
        if (this.contentHash[identifier]) {
          this.elContainer.removeELM(this.contentHash[identifier][1]);
          delete this.contentHash[identifier];
        }
      } else {
        question.updateAnswer(value.values, this.clearAfterId.bind(this));
      }
    } else if (identifier.indexOf("/suggestions") > -1) {
      component = this.createComponent(value);
      identsplit = (identifier || "").split("suggestions/");
      identifier = identsplit[0] + identsplit[1];
      component = (this.contentHash[identifier] || [])[1] || component;
      if (
        value.continue === false &&
        component._option._element.updateSuggestions
      ) {
        this.typingIndicator = null;
        component._option._element.updateSuggestions(value.values, { sendObject: true });
        return;
      }
    } else if (!this.contentHash[identifier]) {

      component = this.createComponent(value)

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else if (this.contentHash[identifier]) {
      if (value.values.suggestions) {
        // If it receives search results but there is  no element, ignore.
        // This prevents it from crashing when cancelling the search while the backend is searching
        if (this.contentHash[identifier][1]._option._element && this.contentHash[identifier][1]._option._element.updateSuggestions) {
          this.contentHash[identifier][1]._option._element.updateSuggestions(value.values, { sendObject: true });
        }
      } else {
        let ch = this.contentHash[identifier];
        this.elContainer.removeELM(ch[1]);

        component = this.createComponent(value)

        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else {
      // TODO: do we need this cache?
      // component = this.contentHash[value.id][1];
    }

    return component;
  }

  createComponent(value) {
    return new Block({
      data: value.values
    });
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;

    //remove questions from parent when the edit come from outside to inside of the module
    if(this.parent && this.parent.contentHash && this.parent.contentHash[this.value.id]) {
      const currentIndex = this.parent.contentHash[this.value.id][0];//index
      Object.keys(this.parent.contentHash).forEach(pKey => {
        const ch = this.parent.contentHash[pKey];
        if(ch[0] > currentIndex) {
          delete this.parent.contentHash[pKey];
          this.parent.elContainer.removeELM(ch[1]);
        }
      });
    }

    if(Object.keys(this.contentHash).length <= 0) {
      this.parent &&
        this.parent.clearAfterId &&
        this.parent.clearAfterId(this.value.id);
    }
  }

  showMore(elm) {
    if (elm) {
      const height = getWindowHeight();
      const bound = elm.getBoundingClientRect();

      if (bound.height > height) {
        ScrollNotification.attachElement(elm);
      }
    }
  }
}

module.exports = InsuranceModuleV2;
